import React from 'react'
import { SimpleGrid, Text } from '@chakra-ui/react'
import { INews } from "../data/types"
import News from "./News"
import { useTranslation } from 'react-i18next'


type NewsPropsList = {
  news?: Array<INews>
}


const NewsList = ({news}: NewsPropsList) => {
  const { t } = useTranslation()

  if (!news || news.length === 0) {
    return (
    <Text textAlign={'center'}>{t('common.noNews')}</Text>
    )
  }
  
  return (

    <SimpleGrid
        width="100%"
        spacing={{ base: 6, md: 8 }}
        templateColumns={{ base: 'minmax(0, 1fr)', md: 'repeat(2, minmax(0, 1fr))', xl: 'repeat(3, minmax(0, 1fr))' }}
      >
        {
          news.map((course, idx) => {
            return (
              <News
                key={course.id || idx}
                title={course.title}
                subTitle={course.subTitle}
                id={course.id}
                image={course.image}
                publicationDate={course.publicationDate}
              />
            )
          }
        )}
    </SimpleGrid>

  )
}

export default NewsList
